module.exports = __webpack_public_path__ + "img/logo.d3c7a6fc.png";